module.exports = __webpack_public_path__ + "static/cust-0d9deeda757f8c1e5c902b6e2d081c03.png";